import { Input } from "antd"
import styles from "./index.module.css"
import { SearchOutlined, CloseCircleOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"

const SearchInput = ({ className, searchBy, setSearchBy, ariaLabel, ariaControls, placeholder }) => {
  const handleClearSearchInput = () => {
    setSearchBy("")
  }

  const handleSearchInput = (e) => {
    setSearchBy(e.target.value)
  }
  return (
    <Input
      type="text"
      placeholder={placeholder}
      value={searchBy}
      onChange={handleSearchInput}
      className={`${className} ${styles.searchInput}`}
      prefix={<SearchOutlined aria-hidden="true" />}
      suffix={searchBy && <CloseCircleOutlined className={styles.clearSearchIcon} onClick={handleClearSearchInput} />}
      aria-label={ariaLabel}
      aria-controls={ariaControls}
      aria-expanded={!!searchBy}
      aria-autocomplete="list"
      aria-activedescendant={searchBy ? ariaControls : undefined}
    />
  )
}

SearchInput.propTypes = {
  searchBy: PropTypes.string.isRequired,
  setSearchBy: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  ariaControls: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string
}

SearchInput.defaultProps = {
  ariaLabel: "search",
  ariaControls: "search-results"
}

export default SearchInput
